<template>
    <content-view
        class="showdata"
    >
        <div class="bg-white pl32 pr32 pt32">
            <div class="text-black-85 font-big bold pb24">展示数据信息</div>
            <a-form
                @submit="handleSubmit"
                :form="form"
            >
                <a-form-item
                    label='区域：'
                    :labelCol="{ span: 7 }"
                    :wrapperCol="{ span: 6 }"
                >
                    <a-select
                        placeholder="请选择区域"
                        @change="areaChange"
                        v-decorator="[
                            'district_code',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message:'请选择区域',

                                    }
                                ]
                            }
                        ]"
                    >
                        <a-select-option
                            v-for="item in statusList"
                            :value="item.district_code"
                            :key="item.district_code"
                        >
                            {{item.district}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item
                    class="form-item"
                    label="今日回收数据："
                    :labelCol="{ span: 7 }"
                    :wrapperCol="{ span: 11 }"
                >
                    <a-row type="flex">
                        <a-col :span="2">
                            增加
                        </a-col>
                        <a-col :span="11" style="text-align: center;">
                            <a-form-item>
                                <a-input
                                    placeholder="请输入"
                                    onfocus="this.removeAttribute('readonly');"
                                    v-decorator="[
                                        'day_total_weight',
                                        
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="2" class="ml8">
                            吨
                        </a-col>
                    </a-row>
                    
                </a-form-item>
                <a-form-item
                    class="form-item"
                    label="近一年回收数据："
                    :labelCol="{ span: 7 }"
                    :wrapperCol="{ span: 11 }"
                >
                    <a-row type="flex">
                        <a-col :span="2">
                            增加
                        </a-col>
                        <a-col :span="11" style="text-align: center;">
                            <a-form-item>
                                <a-input
                                    placeholder="请输入"
                                    onfocus="this.removeAttribute('readonly');"
                                    v-decorator="[
                                        'year_weight',
                                        
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="2" class="ml8">
                            吨
                        </a-col>
                    </a-row>
                    
                </a-form-item>
                <a-form-item
                    class="form-item"
                    label="分拣中心本周回收量："
                    :labelCol="{ span: 7 }"
                    :wrapperCol="{ span: 11 }"
                >
                    <a-row type="flex">
                        <a-col :span="2">
                            增加
                        </a-col>
                        <a-col :span="11" style="text-align: center;">
                            <a-form-item>
                                <a-input
                                    placeholder="请输入"
                                    onfocus="this.removeAttribute('readonly');"
                                    v-decorator="[
                                        'week_weight',
                                        
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="2" class="ml8">
                            吨
                        </a-col>
                    </a-row>
                    
                </a-form-item>
                <a-form-item
                    class="form-item"
                    label="分拣中心累计订单："
                    :labelCol="{ span: 7 }"
                    :wrapperCol="{ span: 11 }"
                >
                    <a-row type="flex">
                        <a-col :span="2">
                            增加
                        </a-col>
                        <a-col :span="11" style="text-align: center;">
                            <a-form-item>
                                <a-input
                                    placeholder="请输入"
                                    onfocus="this.removeAttribute('readonly');"
                                    v-decorator="[
                                        'total_order',
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="2" class="ml8">
                            单
                        </a-col>
                    </a-row>
                    
                </a-form-item>
                <a-form-item
                    class="form-item"
                    label="今日点位回收量："
                    :labelCol="{ span: 7 }"
                    :wrapperCol="{ span: 11 }"
                >
                    <a-row type="flex">
                        <a-col :span="2">
                            增加
                        </a-col>
                        <a-col :span="11" style="text-align: center;">
                            <a-form-item>
                                <a-input
                                    placeholder="请输入"
                                    onfocus="this.removeAttribute('readonly');"
                                    v-decorator="[
                                        'day_weight',
                                        
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="2" class="ml8">
                            吨
                        </a-col>
                    </a-row>
                    
                </a-form-item>
                <a-form-item
                    class="form-item"
                    label="居民参与率排行榜："
                    :labelCol="{ span: 7 }"
                    :wrapperCol="{ span: 11 }"
                >
                    <a-row type="flex">
                        <a-col :span="2">
                            增加
                        </a-col>
                        <a-col :span="11" style="text-align: center;">
                            <a-form-item>
                                <a-input
                                    placeholder="请输入"
                                    onfocus="this.removeAttribute('readonly');"
                                    v-decorator="[
                                        'customer_rate_percen',
                                        
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                    
                </a-form-item>
                <a-form-item
                    class="form-item"
                    label="回收人员在线数："
                    :labelCol="{ span: 7 }"
                    :wrapperCol="{ span: 11 }"
                >
                    <a-row type="flex">
                        <a-col :span="2">
                            设置
                        </a-col>
                        <a-col :span="11" style="text-align: center;">
                            <a-form-item>
                                <a-input
                                    placeholder="请输入"
                                    onfocus="this.removeAttribute('readonly');"
                                    v-decorator="[
                                        'recycling_num',
                                        
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="2" class="ml8">
                            人
                        </a-col>
                    </a-row>
                    
                </a-form-item>
                <a-form-item
                    class="form-item"
                    label="回收站点在线数："
                    :labelCol="{ span: 7 }"
                    :wrapperCol="{ span: 11 }"
                >
                    <a-row type="flex">
                        <a-col :span="2">
                            设置
                        </a-col>
                        <a-col :span="11" style="text-align: center;">
                            <a-form-item>
                                <a-input
                                    placeholder="请输入"
                                    onfocus="this.removeAttribute('readonly');"
                                    v-decorator="[
                                        'station_num',
                                        
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="2" class="ml8">
                            个
                        </a-col>
                    </a-row>
                </a-form-item>
                <a-form-item
                    class="form-item"
                    label="打包站总数："
                    :labelCol="{ span: 7 }"
                    :wrapperCol="{ span: 11 }"
                >
                    <a-row type="flex">
                        <a-col :span="2">
                            增加
                        </a-col>
                        <a-col :span="11" style="text-align: center;">
                            <a-form-item>
                                <a-input
                                    placeholder="请输入"
                                    onfocus="this.removeAttribute('readonly');"
                                    v-decorator="[
                                        'rabbit_device_total',
                                        
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="2" class="ml8">
                            个
                        </a-col>
                    </a-row>
                </a-form-item>
                <a-form-item
                    class="form-item"
                    label="打包站在线数："
                    :labelCol="{ span: 7 }"
                    :wrapperCol="{ span: 11 }"
                >
                    <a-row type="flex">
                        <a-col :span="2">
                            增加
                        </a-col>
                        <a-col :span="11" style="text-align: center;">
                            <a-form-item>
                                <a-input
                                    placeholder="请输入"
                                    onfocus="this.removeAttribute('readonly');"
                                    v-decorator="[
                                        'rabbit_device_num',
                                        
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="2" class="ml8">
                            个
                        </a-col>
                    </a-row>
                </a-form-item>
                <a-form-item
                    class="form-item"
                    label="车辆总数："
                    :labelCol="{ span: 7 }"
                    :wrapperCol="{ span: 11 }"
                >
                    <a-row type="flex">
                        <a-col :span="2">
                            增加
                        </a-col>
                        <a-col :span="11" style="text-align: center;">
                            <a-form-item>
                                <a-input
                                    placeholder="请输入"
                                    onfocus="this.removeAttribute('readonly');"
                                    v-decorator="[
                                        'car_online_total',
                                        
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form-item>
                <a-form-item
                    class="form-item"
                    label="车辆在线数："
                    :labelCol="{ span: 7 }"
                    :wrapperCol="{ span: 11 }"
                >
                    <a-row type="flex">
                        <a-col :span="2">
                            增加
                        </a-col>
                        <a-col :span="11" style="text-align: center;">
                            <a-form-item>
                                <a-input
                                    placeholder="请输入"
                                    onfocus="this.removeAttribute('readonly');"
                                    v-decorator="[
                                        'car_online_num',
                                        
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form-item>
                <a-form-item
                    class="form-item"
                    label="区域每月回收量："
                    :labelCol="{ span: 7 }"
                    :wrapperCol="{ span: 11 }"
                >
                    <a-row type="flex">
                        <a-col :span="2">
                            增加
                        </a-col>
                        <a-col :span="11" style="text-align: center;">
                            <a-form-item>
                                <a-input
                                    placeholder="请输入"
                                    onfocus="this.removeAttribute('readonly');"
                                    v-decorator="[
                                        'mouth_weight',
                                        
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="2" class="ml8">
                            吨
                        </a-col>
                    </a-row>
                    
                </a-form-item>
                <a-form-item
                    class="form-item"
                    label="近一月点位回收量："
                    :labelCol="{ span: 7 }"
                    :wrapperCol="{ span: 11 }"
                >
                    <a-row type="flex">
                        <a-col :span="2">
                            增加
                        </a-col>
                        <a-col :span="11" style="text-align: center;">
                            <a-form-item>
                                <a-input
                                    placeholder="请输入"
                                    onfocus="this.removeAttribute('readonly');"
                                    v-decorator="[
                                        'block_mouth_weight',
                                        
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="2" class="ml8">
                            吨
                        </a-col>
                    </a-row>
                    
                </a-form-item>
                <a-form-item
                    class="form-item"
                    label="每日居民回收量："
                    :labelCol="{ span: 7 }"
                    :wrapperCol="{ span: 11 }"
                >
                    <a-row type="flex">
                        <a-col :span="2">
                            增加
                        </a-col>
                        <a-col :span="11" style="text-align: center;">
                            <a-form-item>
                                <a-input
                                    placeholder="请输入"
                                    onfocus="this.removeAttribute('readonly');"
                                    v-decorator="[
                                        'customer_day_weight',
                                        
                                    ]"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :span="2" class="ml8">
                            kg
                        </a-col>
                    </a-row>
                    
                </a-form-item>
                <a-form-item class="text-center footerButton pt24">
                    <a-button
                        type="primary"
                        htmlType="submit"
                    >保 存</a-button>
                </a-form-item>
            </a-form>
            
        </div>
    </content-view>
</template>

<script>
export default {
    name: "showdata",
    data() {
        return {
            district_code: "",
            form: this.$form.createForm(this),
            statusList:[],
            detail:{},
        };
    },
    watch: {

    },
    methods: {
        // 获得区域列表
        getRole() {
            this.$api.common.regionList().then(res => {
                this.statusList = res.data.list.splice(1);
                this.form.setFieldsValue({"district_code": this.statusList[0].district_code});//默认展示第一个
                this.getDetail(this.statusList[0].district_code);
            });
        },
        // 选择区域
        areaChange(val) {
            this.district_code = val;
            this.getDetail(val);
        },
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.$api.showdata.screenShowSet(values).then(res => {
                        if(res.data.error_no){
                            this.$message.error(res.msg);
                        }else{
                            this.$message.success(res.msg);
                        }
                        
                    });
                    
                }
            });
        },
        // 取消
        cancel() {
            this.$utils.showConfirm(() => {
                this.$router.push({
                    name: "screenvgaList"
                });
            }, this);
        },
        getDetail(id) {
            let formData = {
                district_code: id
            }
            let self = this;
            this.$api.showdata.screenShowInfo(formData).then(res => {
                this.detail = res.data;
                if(res.data){
                    self.$nextTick(() => {
                        let arr = ["day_total_weight","customer_rate_percen","car_online_total","car_online_num","year_weight","week_weight", "day_weight","mouth_weight","block_mouth_weight","total_order","recycling_num","station_num","rabbit_device_total","rabbit_device_num","customer_day_weight"];
                        self.form.setFieldsValue(
                            self.$utils.getRequestData(arr, res.data)
                        );
                    })
                    
                }else{
                    this.form  = this.$form.createForm(this);
                    setTimeout(() => {
                        self.form.setFieldsValue({"district_code": self.district_code});//展示区域
                    },0)
                    
                }
                
            });
        },
    },
    computed: {},
    created() {
        this.getRole();
    }
};
</script>


<style rel="stylesheet/scss" lang="scss">
.wrap-container > div{
    flex: auto;
}
.showdata {
    .bold {
        font-weight: bold;
    }
    .ant-upload.ant-upload-drag {
        height: 202px;
    }
    .ant-upload.ant-upload-drag .ant-upload {
        padding: 0;
    }
    .icon-add {
        font-size: 40px;
    }
    .image {
        height: 200px;
    }
    .ant-checkbox-wrapper {
        width: 175px;
    }
    .editbtn {
        color: rgba(8, 106, 204, 1);
    }
}
.ql-picker,
.ql-picker-label {
    line-height: 24px;
}
</style>
